import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import React from "react";

import { CustomerForm } from "../../../../customers/CustomerForm";

import { useAddOwnerFlow } from "./AddOwnerFlowContext";


export function CustomerRegisterDialog() {
    const {
        box,
        openNewCustomerDialog,
        setOpenNewCustomerDialog,
        handleNewCustomer,
    } = useAddOwnerFlow();

    return (
        <Dialog
            open={openNewCustomerDialog}
            onClose={() => setOpenNewCustomerDialog(false)}
        >
            <DialogTitle>
                Register New Customer
            </DialogTitle>
            <DialogContent
                style={{
                    minHeight: "400px",
                    minWidth: "400px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                }}>
                <CustomerForm
                    callback={handleNewCustomer}
                    close={() => setOpenNewCustomerDialog(false)}
                    orgId={box.orgId}
                    siteId={box.siteId}
                />
            </DialogContent>
        </Dialog>
    );
}
